export default __webpack_public_path__ + "static/media/education-anaytics.28dd517f.svg";